import React from "react";
import QuestionMark from "../../../assets/Icon/QuestionMark";
import CustomInput from "../../UI/CustomInput";
import cs from "classnames";
import TooltipButton from "../../UI/TooltipButton";

const StepOne = ({
  data,
  setData,
  calculatorType,
  handleBlur,
  dataError,
  setDataError,
  handleEnter,
}) => {
  const handleChange = ({ target: { value, name } }) => {
    if (value) {
      ["calc-1", "calc-3", "calc-4"].includes(calculatorType)
        ? setDataError({ ...dataError, listingPriceError: false })
        : calculatorType === "calc-5"
        ? setDataError({ ...dataError, materialsError: false })
        : setDataError({ ...dataError, profitError: false });
    } else {
      ["calc-1", "calc-3", "calc-4"].includes(calculatorType)
        ? setDataError({ ...dataError, listingPriceError: true })
        : calculatorType === "calc-5"
        ? setDataError({ ...dataError, materialsError: true })
        : setDataError({ ...dataError, profitError: true });
    }
    setData({ ...data, [name]: value });
  };

  return (
    <div>
      <p className="mt-5 mb-0">
        {calculatorType === "calc-1" && "What is your listing price?"}
        {calculatorType === "calc-2" && "What is the profit per product?"}
        {calculatorType === "calc-3" && "What is your listing price?"}
        {calculatorType === "calc-4" && "What is your listing price?"}
        {calculatorType === "calc-5" &&
          "What did this product cost you to make and ship?"}

        <TooltipButton
          title={
            calculatorType === "calc-1"
              ? "Ex: You list your homemade candle for $20."
              : calculatorType === "calc-2"
              ? "Ex: The profit for your homemade candle is $20."
              : calculatorType === "calc-3"
              ? "Ex: You list your homemade candle for $20."
              : calculatorType === "calc-4"
              ? "Ex: You list your homemade candle for $20."
              : calculatorType === "calc-5"
              ? "Ex: You list your product cost candle for $3."
              : ""
          }
          placement="top"
          icon={<QuestionMark />}
        />
      </p>
      <div className="d-flex align-items-center">
        <span className="font-currency mr-2">$</span>
        <CustomInput
          formControlClass="time-input"
          className={cs(
            {
              ["error-input"]: dataError.listingPriceError,
            },
            {
              ["error-input"]: dataError.profitError,
            },
            {
              ["error-input"]: dataError.materialsError,
            }
          )}
          name={
            ["calc-1", "calc-3", "calc-4"].includes(calculatorType)
              ? "listingPrice"
              : calculatorType === "calc-5"
              ? "materials"
              : "profit"
          }
          placeholder="00.00"
          type="number"
          min="0"
          onBlur={handleBlur}
          value={
            ["calc-1", "calc-3", "calc-4"].includes(calculatorType)
              ? data.listingPrice
              : calculatorType === "calc-5"
              ? data.materials
              : data.profit
          }
          onChange={handleChange}
          autoFocus
          onKeyPress={handleEnter}
        />
      </div>
    </div>
  );
};
export default StepOne;
